import {
  AutoComplete,
  Breadcrumb,
  DatePicker,
  Input,
  Modal,
  Pagination,
  Progress,
  Select,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../component/button/PrimaryButton";
import {
  AddIcon,
  ArrowGreen,
  ArrowRed,
  AscRed,
  CloseIconSearch,
  DAIcon,
  DateIcon,
  DescGrey,
  PicDB,
  SearchIcon,
  TripIcon,
  WeightIcon,
  WorkHourIcon,
} from "../../asset";
import style from "./Dashboard.module.css";
import SecondaryButton from "../../component/button/SecondaryButton";
import MultipleSelectSearchDepot from "../../component/multiple-select-search/mss-depot";
import { useEffect, useState } from "react";
import {
  GROLOG_DR_URL,
  GROLOG_ORDER_URL,
  GROLOG_URL,
} from "../../constant/apiConstant";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CustomTable from "../../component/table/CustomTable";
import CustomPaging from "../../component/pagination/pagination";
import RangeDatePicker from "../../component/range-date-picker/RangeDatePicker";
import { setGlobalDepotName, setGlobalIsGetDetail } from "../../store/reducer/globalMultipleSearchSelect.reducer";
import CustomHover from "../../component/custom-hover/CustomHover";
import moment from "moment";
import _, { sortBy } from "lodash";
import dayjs from "dayjs";
import { setGlobalDDLDatePeriodDB } from "../../store/reducer/globalDDL.reducer";
import DDLDatePeriod from "../../component/dropdown-list/ddl-date-period-db";

import { Pie } from '@ant-design/plots';
import { Line } from '@ant-design/charts';
import MSSDepot from "../../component/mss/depot";

const Dashboard = () => {
  const { t } = useTranslation();
  const {
    globalOrderFrom,
    globalDepotName,
    setGlobalDAStatus,
    setGlobalDA,
    setGlobalOrderStatus,
    setGlobalTrip,
    setGlobalTripStatus,
  } = useSelector((state) => state.globalMSS);  
  const {
    globalDDLDatePeriodDB
  } = useSelector((state) => state.globalDDL);
  const { RangePicker } = DatePicker;
  const [trip, setTrip] = useState();
  const [order, setOrder] = useState();
  const [deliveryAssociate, setDeliveryAssociate] = useState();
  const [loadingWeight, setLoadingWeight] = useState();
  const [workHour, setWorkHour] = useState();
  const [initTrip, setInitTrip] = useState();
  const [initLoadingWeight, setInitLoadingWeight] = useState();
  const [initWorkHour, setInitWorkHour] = useState();
  const [initOrder, setInitOrder] = useState();
  const [initDeliveryAssociate, setInitDeliveryAssociate] = useState();
  const [pageTrip, setPageTrip] = useState();
  const [pageLoadingWeight, setPageLoadingWeight] = useState(1);
  const [pageWorkHour, setPageWorkHour] = useState(1);
  const [sorting, setSorting] = useState("asc");
  const [visible, setVisible] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState()
  const [isFilter, setIsfilter] = useState(false)
  const [filters, setFilters] = useState("")
  const [sortingBy, setSortingBy] = useState("not_started")
  const [searchRecommendation, setSearchRecommedation] = useState("");
  const [listRecommendation, setListRecommendation] = useState([]);
  const [date, setDate] = useState({
    filter: "Today",
    from_date: "",
    thru_date: "",
  });
  const [filter, setFilter] = useState({
    depot: {
      list_id: [-1],
      exclude: false,
    },
    date: {
      filter: "Today",
      from_date: "",
      thru_date: "",
    },
  });
  const dates = [
    { value: "Today", label: "Today" },
    { value: "This Week", label: "This Week" },
    { value: "This Month", label: "This Month" },
    { value: "Last 3 Month", label: "Last 3 Month" },
    { value: "This Year", label: "This Year" },
    { value: "Custom Date", label: "Custom Date" },
  ];
console.log("ddl",globalDDLDatePeriodDB);
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const dispatch = useDispatch();

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;
    // const api = `http://app.sbp:9005/manager/v1/grolog`;
    // if(validateExpired(token,dispatch,refresh_token)) {
    //   token = await doRefreshToken(token,dispatch);
    // }

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
      // "X-NEXAUTH-CHECK":"FIXED",
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  useEffect(() => {
    dispatch(setGlobalDepotName([-1]));
    dispatch(setGlobalDDLDatePeriodDB({
              filter: "Today",
        from_date: "",
        thru_date: ""
    }));
    dispatch(setGlobalIsGetDetail(true))
  }, []);
  useEffect(() => {
    fetchDataTrip();
  }, [filter, filters, sorting, sortingBy]);

  useEffect(() => {
    fetchDataLoadingWeight();
  }, [filter]);

  useEffect(() => {
    fetchDataOrder();
  }, [filter]);

  useEffect(() => {
    fetchDataDeliveryAssociate();
  }, [filter]);

  useEffect(() => {
    fetchDataWorkHours();
  }, [filter]);

  const fetchDataTrip = async () => {
    try {
      let tkn = token;
      let sub = {
        ...filter,
        list_request: {
          page: "1",
          limit: "6",
          order: `${sortingBy} ${sorting}`,
          filter:filters ? `depot_name lk ${filters}` :""
        },
      };
      let res = await doPost(`/dashboard/trip?${param}`, token, sub);
      setTrip(res?.data.payload.data);
      let res2 = await doPost(`/dashboard/trip/initiate?${param}`, token, sub);
      setInitTrip(res2?.data.payload.data);
    } catch (err) {
      if (
        err?.response?.data?.payload?.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
      } else {
      }
    }
  };

  const fetchDataLoadingWeight = async (page) => {
    try {
      let tkn = token;
      let sub = {
        ...filter,
        list_request: {
          page: `${page ? page : pageLoadingWeight}`,
          limit: "6",
        },
      };
      let res = await doPost(`/dashboard/loading-weight?${param}`, token, sub);
      setLoadingWeight(res?.data.payload.data);
      let res2 = await doPost(
        `/dashboard/loading-weight/initiate?${param}`,
        token,
        sub
      );
      setInitLoadingWeight(res2?.data.payload.data);
    } catch (err) {
      if (
        err?.response?.data?.payload?.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
      } else {
      }
    }
  };

  const fetchDataOrder = async () => {
    try {
      let tkn = token;
      let sub = {
        ...filter,
      };
      let res = await doPost(`/dashboard/total-order?${param}`, token, sub);
      setOrder(res?.data.payload.data);
    } catch (err) {
      if (
        err?.response?.data?.payload?.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
      } else {
      }
    }
  };

  const fetchDataDeliveryAssociate = async () => {
    try {
      let tkn = token;
      let sub = {
        ...filter,
      };
      let res = await doPost(
        `/dashboard/delivery-associate?${param}`,
        token,
        sub
      );
      setDeliveryAssociate(res?.data.payload.data);
    } catch (err) {
      if (
        err?.response?.data?.payload?.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
      } else {
      }
    }
  };

  const fetchDataWorkHours = async (page) => {
    try {
      let tkn = token;
      let sub = {
        ...filter,
        list_request: {
          page: `${page ? page : pageWorkHour}`,
          limit: "6",
        },
      };
      let res = await doPost(`/dashboard/work-hours?${param}`, token, sub);
      setWorkHour(res?.data.payload.data);
      let res2 = await doPost(
        `/dashboard/work-hours/initiate?${param}`,
        token,
        sub
      );
      setInitWorkHour(res2?.data.payload.data);
    } catch (err) {
      if (
        err?.response?.data?.payload?.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
      } else {
      }
    }
  };
  const handlePaginationWorkHour = async (a) => {
    if (a) {
      setPageWorkHour(a);
      await fetchDataWorkHours(a);
    }
  };
  const handlePaginationLoadingWeight= async (a) => {
    if (a) {
      setPageLoadingWeight(a);
      await fetchDataLoadingWeight(a);
    }
  };
  const dataSource = trip?.list_trip
    ? trip?.list_trip?.map((result) => ({
        name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.depot_name}
          </span>
        ),

        desc: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.new_trip}
          </span>
        ),
        toMenu: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.finished}
          </span>
        ),
      }))
    : null;
  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Depot")}
        </span>
        
      ),
      dataIndex: "name",
      key: "name",
      // sorter: {
      //   compare: (a, b) => a.name.localeCompare(b.name),
      // },
      render: (name) => <span>{name}</span>,
    },

    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("New Trip")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="not_started" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="not_started" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "not_started");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="not_started" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="not_started" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "not_started");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "desc",
      key: "desc",
      render: (desc) => <span>{desc}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Finished Trip")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="finished" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="finished" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "finished");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="finished" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="finished" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "finished");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "toMenu",
      key: "toMenu",
      render: (toMenu) => <span>{toMenu}</span>,
    },
  ];
  // const handlePagination = (a,b)=>{
  //   if (a && b) {
  //     setPage(a)
  //     setLimit(b)
  //   } else {

  //   }
  // };

  const doSort = async (sort, sortBy) => {
    await setSortingBy(sortBy)
    await setSorting(sort);
    if (sort && sortBy) {
    await setSorting(sort);
    await setSortingBy(sortBy)
    // fetchData("", sort, sortBy);
    }
  };
  const handleChange = (value, name) => {
    if (name === "period") {
      if (value === "Custom Date") {
        setVisible(true);
      } else {
        let periods = {
          filter: value,
          from_date: "",
          thru_date: "",
        };
        setDate(periods);
      }
    }
  };

  const handleFilterDate =()=>{
    let periods = {
      filter: "Custom Date",
      from_date: moment(new Date(fromDate)).format("YYYY-MM-DD"),
      thru_date: moment(new Date(toDate)).format("YYYY-MM-DD"),
    };
    setDate(periods)
    setVisible(false)
  }

  const handleFilter = () => {
    setFilter({
      ...filter,
      depot: {
        list_id:
          globalDepotName[0] !== -1
            ? globalDepotName?.map((el) => el?.id)
            : globalDepotName,
        exclude: false,
      },
      date: globalDDLDatePeriodDB,
    });
  };

  const handleResetFilter = () => {
    dispatch(setGlobalDepotName([-1]));
    dispatch(setGlobalDDLDatePeriodDB({
              filter: "Today",
        from_date: "",
        thru_date: ""
    }));
    dispatch(setGlobalIsGetDetail(true))
    setFilter({
      depot: {
        list_id: [-1],
        exclude: false,
      },
      date: {
        filter: "Today",
        from_date: "",
        thru_date: "",
      },
    });
    setDate({
      filter: "Today",
      from_date: "",
      thru_date: "",
    });
  };
console.log("frto", fromDate, toDate);
  const handleChangeDate = (value)=>{
    console.log("value",dayjs(value[0]).toISOString());
    setFromDate(dayjs(value[0]).toISOString())
    setToDate(dayjs(value[1]).toISOString())
  //   _.map(
  //     value,
  //     (item, index) =>
  //         (index === 0 &&
  //             setFromDate(moment(item).toISOString())
  //             ) ||
  //         (index === 1 &&
  //             setToDate(moment(item).toISOString()))
  // );
  }

  const setResetDate = () =>{
    setFromDate()
    setToDate()
    setVisible(false)
  }
  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));
    const fetchRecommendation = async (
      page,
      limit,
      filters,
      mapping_principal_id
    ) => {
      if (filters.length >= 1) {
        let sub = {
          ...filter,
          list_request: {
            page: "1",
            limit: "6",
            filter: `depot_name lk ${filters}`,
          },
        };
        let res = await doPost(`/dashboard/trip/search?${param}`, token, sub);
        setListRecommendation(res?.data?.payload?.data);
      }
    };
  
    const onSearchRecommendation = async (value) => {
      setSearchRecommedation(value);
      setIsfilter(true);
      if (value) {
        setSearchRecommedation(value);
        await fetchRecommendation(1, 10, value);
      } else {
      }
    };
  
    const onSelectRecommendation = (data) => {
      setPageTrip(1)
      setFilters(data);
      fetchDataTrip(data, sorting, 1);
      setIsfilter(false);
    };
  
    const onClearRecommendation = (e) => {
      setIsfilter(false);
      setFilters(null);
      setSearchRecommedation("");
      setListRecommendation([]);
  
      fetchDataTrip("",sorting, 1);
  
    };

    const config = {
      data: [
        { type: `Owned (${deliveryAssociate?.owned_delivery_associate})`, value: deliveryAssociate?.owned_delivery_associate },
        { type: `Outsource (${deliveryAssociate?.outsource_delivery_associate})`, value: deliveryAssociate?.outsource_delivery_associate },
    
      ],
      appendPadding: 10,
      angleField: 'value',
      colorField: 'type',
      radius: 1,
      innerRadius: 0.6,
      label: {
        // type: 'inner',
        offset: '-30%',
        content: function content(_ref) {
          const { type, value } = _ref;
          return `${type}: ${value}`;
        },
        style: {
          fontSize: 14,
          textAlign: 'center',
        },
      },
      interactions: [{ type: 'element-active' }],
      // interactions: [
      //   { type: 'element-selected' }, 
      //   { type: 'element-active' }],
      // statistic: {
      //   title: false,
      //   content: {
      //     style: {
      //       whiteSpace: 'pre-wrap',
      //       overflow: 'hidden',
      //       textOverflow: 'ellipsis',
      //     },
      //     content: 'AntV\nG2Plot',
      //   },
      // },
      annotations: [
        {
          type: 'text',
          style: {
            text: `${deliveryAssociate?.total_delivery_associate}`,
            x: '50%',
            y: '50%',
            textAlign: 'center',
            fontSize: 30,
            fontStyle: 'bold',
          },
        },
      ],
      // angleField: 'value',
      // colorField: 'type',
      // paddingRight: 50,
      // innerRadius: 0.6,
      // label: {
      //   text: 'value',
      //   style: {
      //     fontWeight: 'bold',
      //   },
      // },
      legend: {
        color: {
          title: false,
          position: 'right',
          rowPadding: 10,
        },
      },
      // annotations: [
      //   {
      //     type: 'text',
      //     style: {
      //       text: `${deliveryAssociate?.total_delivery_associate}`,
      //       x: '50%',
      //       y: '50%',
      //       textAlign: 'center',
      //       fontSize: 30,
      //       fontStyle: 'bold',
      //     },
      //   },
      // ],
    };
  console.log("DA", deliveryAssociate);
  console.log("Order", order);
  console.log("trip", trip, initTrip);
  console.log("lw", loadingWeight, initLoadingWeight);
  console.log("wh", workHour, initWorkHour);
  console.log("dpt", globalDepotName);
  return (
    <>
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
            {/* <Breadcrumb.Item>Order Request</Breadcrumb.Item> */}
          </Breadcrumb>
        </div>
        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Dashboard")}
        </h1>
        <div className={style.headerContainer + " flex mr-2"}>
          <div className="w-[300px] h-full">
            <MSSDepot />
          </div>
          <div className="w-[300px] h-full ml-3">
          <DDLDatePeriod/>
          </div>
          {/* <Select
            className="w-[300px] ml-2"
            dropdownStyle={{
              backgroundColor: "white",
            }}
            size="large"
            value={date?.filter === "Custom Date" ? `${date?.from_date} - ${date?.thru_date}` : date?.filter}
            onChange={(value) => handleChange(value, "period")}
            options={dates}
            suffixIcon={<img src={DateIcon} alt="date" />}
          /> */}
          <Modal
            open={visible}
            // width={"350px"}
            width={650}
            // className="h-[400px]"
            onCancel={() => setVisible(false)}
            footer={
              <div>
                <div style={{ flexDirection: "row" }}>
                  {/* <ErrorMessage
                   children={
                     save === false &&
                     this.props.t("COMMON:VALID_RANGE_DATE", {
                       len:90,
                     })
                   }
                 /> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    margin: "3px",
                  }}
                >
                  <PrimaryButton
                    styles={" mr-2"}
                    action = {()=>handleFilterDate()}
                    text={t("Save")}
                  />
                  <SecondaryButton
                    action={() => setResetDate()}
                    text={t("Cancel")}
                  />
                </div>
              </div>
              //        );
            }
          >
            <div className="w-[700px] h-96">
              <RangePicker
              // disabledDate={(current)=> {
              //       return current && current.isAfter(moment().add(1, 'day').startOf('day'))
              //     }}
                className={style.datePicker}
                defaultOpen={visible}
                // open={visible}
                showTime={false}
                onChange={(e) => handleChangeDate(e)}
                
                separator="-"
                // value={[dayjs(fromDate), dayjs(toDate)]}
              />
            </div>
          </Modal>
          <SecondaryButton
            text={t("Reset")}
            // disabled
            styles=" mr-2 ml-2"
            // prefixIcon={<AddIcon/>}
            // actions="dashboard"
            action={() => handleResetFilter()}
          />
          <PrimaryButton
            text={t("Apply")}
            // prefixIcon={<AddIcon/>}
            // actions="dashboard"
            action={() => handleFilter()}
          />
        </div>
        {/* start body dashboard */}
        <div className="h-auto">
          <div className="flex">
            <div className="w-1/2 max-w-[758px]">
              {/* TRIP */}
              <div
                className={
                  "mr-4 p-[24px] mb-[24px] h-[538px] bg-[#ffffff] rounded-md border-[1px]"
                }
              >
                <div className="flex">
                  <img src={TripIcon} alt="trip" />
                  <div className="font-sans mt-3 ml-2 font-bold text-2xl h-[33px]">
                    Trip
                  </div>
                </div>
                <div className="flex justify-between mb-2 w-[100%]">
                  <div className="w-[400px] mt-3">
                  <AutoComplete
              options={options}
              value={searchRecommendation}
              onChange={(value) => onSearchRecommendation(value)}
              onSelect={(value) => onSelectRecommendation(value)}
              //  allowClear={true}
            >
              <Input
                placeholder={t("Search Name")}
                suffix={
                  <img
                    onClick={filters ? () => onClearRecommendation() : null}
                    src={filters ? CloseIconSearch : SearchIcon}
                    alt="search"
                  />
                }
                value={searchRecommendation}
                width={500}
                className="w-[500px] h-[47px]"
              />
            </AutoComplete>
                  </div>
                  <div className="p-4 mt-[-40px] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100px] mt-2 cursor-pointer">
                    <div className="flex justify-start">

                    <div className="w-[180px] mb-[24px]">
                          <label className="font-roboto text-[14px] text-[#818181]">
                            {t("New Trip")}
                          </label>
                          <h4 className="font-roboto text-[20px] text-[#424242]">
                            {trip?.trip?.new_trip}
                          </h4>
                        </div>
                        
                        <div className="w-[180px] mb-[24px]">
                          <label className="font-roboto text-[14px] text-[#818181]">
                            {t("Finished Trip")}
                          </label>
                          <h4 className="font-roboto text-[20px] text-[#424242]">
                            {trip?.trip?.finished}
                          </h4>
                        </div>
                    </div>
                  </div>

                </div>
                {/* {
  // !loading ? */}
                <div className={style.tableContainer}>
                  <CustomTable columns={ListColumn} data={dataSource} />
                  <div className={style.containerPagination + " mt-[-45px]"}>
                    <CustomPaging
                      idLimit="ddlrowsperpagemustselllist"
                      idPagination="btnpaginationmustselllist"
                      size="small"
                      // current={page}
                      // defaultCurrent={page}
                      // pageSize={limit}
                      // total={initiate && initiate?.count_data}
                      // pageSizeOptions={initiate && initiate?.valid_limit}
                      // onShowSizeChange={() => handlePagination()}
                      // handlePaging={(a,b) => handlePagination(a,b)}
                      // title={t("COMMON:ROW_PAGE")}
                    />
                  </div>
                </div>
                {/* // : "...loading"} */}
              </div>

              {/* OPTIMIZING WORK HOUR AND PRODUCTIVITY AVERAGE */}
              <div
                className={
                  "p-[24px] mr-4 h-[300px] bg-[#ffffff] rounded-md border-[1px]"
                }
              >
                <div className="flex h-[48px]">
                  <img src={WorkHourIcon} alt="trip" />
                  <div className="font-sans mt-3 ml-2 font-bold text-2xl h-[33px]">
                    Optimizing Work Hours Productivity Average
                  </div>
                </div>
                <div className="flex">
                  <div>
                    <Progress
                      type="dashboard"
                      percent={workHour?.total_percentage}
                      // success={{
                      //   percent: 30,
                      // }}
                      strokeWidth={15}
                      strokeColor="#FAC46E"
                      width={192}
                    />
                  </div>
                  <div className="max-w-[716px] p-2 w-[100%] ">
                    <div className="max-w-[716px] p-2 w-[100%] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100%] mt-2 cursor-pointer">
                      <div className={"w-[100%] "}>
                        <h4 className="font-roboto text-[20px] font-medium">
                          Total Depot : {initWorkHour?.count_data}
                        </h4>
                      </div>
                      <div
                        className={style.gridContainer + " h-[65%]"}
                        style={{ display: "grid" }}
                      >
                        {workHour?.list_work_hours_productivity?.map((el) => {
                          return (
                            <>
                              <div className={style.gridItem}>
                                <h4 className="font-roboto text-[16px] text-[#424242] flex justify-between">
                                  <span>
                                  
        <CustomHover limit={17} value={el?.depot_name}/>
                                  </span>
                                  <span
                                    className={`${
                                      el?.percentage >= 80
                                        ? "text-green-50"
                                        : el?.percentage < 80 &&
                                          el?.percentage >= 50
                                        ? "text-[#ffc337]"
                                        : "text-red-100"
                                    } mr-4`}
                                  >
                                    {el?.percentage}%
                                  </span>
                                </h4>
                              </div>
                            </>
                          );
                        })}
                      </div>

                      <div className={style.Wrap + " justify-end flex "}>
                        <Pagination
                          onShowSizeChange={false}
                          current={pageWorkHour}
                          defaultCurrent={pageWorkHour}
                          pageSize={6}
                          total={initWorkHour?.count_data}
                          onChange={(value) =>
                            handlePaginationWorkHour(value, 6)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/2 max-w-[758px]">
              {/* TOTAL ORDER */}
              <div
                className={
                  "p-[24px] mr-5 mb-[24px] h-[218px] bg-[#ffffff] rounded-md border-[1px]"
                }
              >
                <div className="">
                  <div className=" h-[33px] flex-col col-start-2 isolate">
                    <div className="flex justify-between w-full">
                    <div className="font-sans font-bold text-2xl mb-3">
                      Total Order
                    </div>
                    <div className="flex justify-end mr-2">
                    <div className="font-semibold text-2xl mb-3 mr-1">
                      {order?.total_order}
                    </div>
                    <div className="ml-1">
                      { order?.order_difference_percentage !==0 ?
                      <div className="flex">
                      <img src={order?.order_difference_percentage >0 ? ArrowGreen : order?.order_difference_percentage <0 ? ArrowRed : ""} className={order?.order_difference_percentage >0 ? "" : order?.order_difference_percentage <0 ? "rotate-90" : ""}/>
                      <span className={`ml-1 ${order?.order_difference_percentage >0 ? "text-green-50" : order?.order_difference_percentage <0 ? "text-red-100" : ""}`}>{order?.total_order_difference} {"("+ order?.order_difference_percentage+" %)"}</span>
                      </div> :
                      <span> = {order?.total_order_difference} {"("+ order?.order_difference_percentage+" %)"}</span>
                      } 
                      <span className="mt-[-2px] text-[#818181]">{order?.date_comparator}</span>
                    </div>
                    </div>
                    </div>
              </div>
                    <div className="flex">
                      <div className="">
                        <div className="w-[350px] mb-[24px]">
                          <label className="font-roboto text-[14px] text-[#818181]">
                            {t("New Order")}
                          </label>
                          <h4 className="font-roboto text-[20px] text-[#424242]">
                            {order?.total_new_order}
                          </h4>
                        </div>

                        <div className="w-[350px] mb-[24px]">
                          <label className="font-roboto text-[14px] text-[#818181]">
                            {t("received")}
                          </label>
                          <h4 className="font-roboto text-[20px] text-[#424242]">
                            {order?.total_received_order}
                          </h4>
                        </div>
                      </div>
                      <div className="">
                        <div className="w-[350px] mb-[24px]">
                          <label className="font-roboto text-[14px] text-[#818181]">
                            {t("On Process")}
                          </label>
                          <h4 className="font-roboto text-[20px] text-[#424242]">
                            {order?.total_on_process_order}
                          </h4>
                        </div>

                        <div className="w-[350px] mb-[24px]">
                          <label className="font-roboto text-[14px] text-[#818181]">
                            {t("Reassign")}
                          </label>
                          <h4 className="font-roboto text-[20px] text-[#424242]">
                            {order?.total_reassign_order}
                          </h4>
                        </div>
                    </div>
                      
                    </div>
                  </div>
                </div>

              {/* DELIVERY ASSOCIATE */}
              <div
                className={
                  "p-[24px] mr-5 mb-[24px] h-[296px] bg-[#ffffff] rounded-md border-[1px]"
                }
              >
                <div className="flex h-[48px]">
                  <img src={DAIcon} alt="trip" />
                  <div className="font-sans mt-3 ml-2 font-bold text-2xl h-[33px]">
                    Delivery Associate
                  </div>
                </div>
                <div className="flex">
                  <div>
                    <Pie
                    width={250}
                    height={250}
                    {...config}/>
                    {/* <Progress
                      percent={100}
                      success={{
                        percent: 30,
                      }}
                      type="circle"
                      strokeWidth={15}
                      width={192}
                    /> */}
                  </div>
                  <div className="max-w-[716px] p-2 w-[100%] mb-2 ">
                    <div className="max-w-[716px] p-2 w-[100%] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100px] cursor-pointer">
                      <div className={"w-[100%] mb-1"}>
                        <h4 className="font-roboto text-[20px] text-[#424242]">
                          Driver
                        </h4>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className={"w-[50%]"}>
                          <div className="mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Total")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {deliveryAssociate?.total_driver}
                            </h4>
                          </div>
                        </div>
                        <div className="w-[50%] flex justify-start">
                          <div className="mb-[24px] w-[50%]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Active")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {deliveryAssociate?.active_driver}
                            </h4>
                          </div>
                          <div className="mb-[24px] w-[50%]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Expired")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {deliveryAssociate?.expired_driver}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="max-w-[716px] p-2 w-[100%] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100px] mt-2 cursor-pointer">
                      <div className={"w-[100%] mb-1"}>
                        <h4 className="font-roboto text-[20px] text-[#424242]">
                          Vehicle
                        </h4>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className={"w-[50%]"}>
                          <div className="mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Total")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {deliveryAssociate?.total_vehicle}
                            </h4>
                          </div>
                        </div>
                        <div className="w-[50%] flex justify-start">
                          <div className="mb-[24px] w-[50%]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Active")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {deliveryAssociate?.active_vehicle}
                            </h4>
                          </div>
                          <div className="mb-[24px] w-[50%]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Expired")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {deliveryAssociate?.expired_vehicle}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* OPTIMIZING LOADING WEIGHT AVERAGE */}
              <div
                className={
                  "p-[24px] mr-4 h-[300px] bg-[#ffffff] rounded-md border-[1px]"
                }
              >
                <div className="flex h-[48px]">
                  <img src={WeightIcon} alt="trip" />
                  <div className="font-sans mt-3 ml-2 font-bold text-2xl h-[33px]">
                    Optimizing Loading Weight Average
                  </div>
                </div>

                <div className="flex">
                  <div>
                    <Progress
                      type="dashboard"
                      percent={loadingWeight?.total_percentage}
                      // success={{
                      //   percent: 30,
                      // }}
                      strokeWidth={15}
                      strokeColor="#DA5D4D"
                      width={192}
                    />
                  </div>
                  <div className="max-w-[716px] p-2 w-[100%] ">
                    <div className="max-w-[716px] p-2 w-[100%] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100%] mt-2 cursor-pointer">
                      <div className={"w-[100%] "}>
                        <h4 className="font-roboto text-[20px] font-medium">
                          Total Depot : {initLoadingWeight?.count_data}
                        </h4>
                      </div>
                      <div
                        className={style.gridContainer + " h-[65%]"}
                        style={{ display: "grid" }}
                      >
                        {loadingWeight?.list_optimizing_average?.map((el) => {
                          return (
                            <>
                              
                              <div className={style.gridItem}>
                                <h4 className="font-roboto text-[16px] text-[#424242] flex justify-between">
                                  <span>
                                  
        <CustomHover limit={17} value={el?.depot_name}/>
                                  </span>
                                  <span
                                    className={`${
                                      el?.percentage >= 80
                                        ? "text-green-50"
                                        : el?.percentage < 80 &&
                                          el?.percentage >= 50
                                        ? "text-[#ffc337]"
                                        : "text-red-100"
                                    } mr-4`}
                                  >
                                    {el?.percentage}%
                                  </span>
                                </h4>
                              </div>
                            </>
                          );
                        })}
                      </div>

                      <div className={style.Wrap + " justify-end flex "}>
                        <Pagination
                          onShowSizeChange={false}
                          current={pageLoadingWeight}
                          defaultCurrent={pageLoadingWeight}
                          pageSize={6}
                          total={initLoadingWeight?.count_data}
                          onChange={(value) =>
                            handlePaginationLoadingWeight(value, 6)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="flex justify-between">
          <div className={"w-1/2 mr-4 h-[300px] bg-[#ffffff] rounded-md shadow-lg "}>

          </div>

          <div className={"w-1/2 mr-4 h-[300px] bg-[#ffffff] rounded-md shadow-lg "}>

          </div>
          </div> */}
          </div>
          {/* <Progress
          percent={100}
          success={{
            percent: 30,
          }}
          type="circle"
          strokeWidth={10}
          width={200}
        /> */}
        </div>
      </div>
    </>
  );
};
export default Dashboard;
